export default class VideoComponentState {
  chapteredVideoSource: any;
  loading: boolean = true;
  isAtEnd: boolean = false;
  ctrlCurrentTime: number = 0;
  useHls: boolean = false;
  videoContainerClassName: string = '';
}
